<template>
  <div class="jade-feedback">
    <jade-icon-shape
      size="large"
      :variant="variant"
      :use="computedIcon"
    />
    <div class="jade-feedback__content">
      <jade-text
        variant="display-small"
        color="high"
        data-testid="title-text"
      >
        {{ title }}
      </jade-text>
      <jade-text
        v-if="description"
        variant="text-medium"
        weight="regular"
        color="medium"
        data-testid="description-text"
      >
        {{ description }}
      </jade-text>
    </div>
    <slot />
  </div>
</template>

<script>
import JadeText from '../JadeText/index.vue'
import JadeIconShape from '../JadeIconShape/index.vue'
import COLOR_ENUM from '../enums/colors.enum'

export default {
  name: 'JadeFeedback',
  components: {
    JadeText,
    JadeIconShape
  },
  props: {
    title: {
      type: String,
      required: true
    },
    description: String,
    variant: {
      type: String,
      validation: color =>
        [
          COLOR_ENUM.NEGATIVE,
          COLOR_ENUM.WARNING,
          COLOR_ENUM.POSITIVE,
          COLOR_ENUM.NEUTRAL
        ].includes(color),
      default: COLOR_ENUM.NEUTRAL
    }
  },
  computed: {
    computedIcon () {
      const icon = {
        [COLOR_ENUM.NEUTRAL]: 'circle-info',
        [COLOR_ENUM.POSITIVE]: 'circle-check',
        [COLOR_ENUM.NEGATIVE]: 'circle-error',
        [COLOR_ENUM.WARNING]: 'circle-alert'
      }
      return icon[this.variant]
    }
  }
}
</script>
